import React, { useEffect } from "react";
import HomeContentSubTitle from "./HomeContentSubTitle";
import { TodayCommunityWrapper } from "./HomeTodayCommunityStyle";
import CommentSvg from "assets/icons/comment.svg";
import LikeSvg from "assets/icons/like.svg";
import ScrollContainer from "react-indiana-drag-scroll";
import { useDispatch } from "react-redux";
import { HomeCreators } from "redux/modules/home";
import RecommendedPosts from "../community/main/RecommendedPosts";

const HomeTodayCommunity = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // TODO: auth 관련 인증 마무리되고 추후에 연결 필요
    // dispatch(HomeCreators.fetchPopularBoardList());
  }, []);
  return (
    <TodayCommunityWrapper>
      <HomeContentSubTitle
        title="인기 게시글"
        routingTitle="커뮤니티 전체보기"
        path="/boards"
      />
      <RecommendedPosts />
    </TodayCommunityWrapper>
  );
};

export default HomeTodayCommunity;
